'use client';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Icon from '../Icon';
import Status from '../Status';
import { t } from '../../i18n';
import s from './CategoryHeader.module.scss';

const CategoryHeader = ({
    label = '',
    count = 0,
    isOpen = false,
    isPinned = false,
    hasNewReports = false,
    showPin = true,
    showToggle = true,
    modifiers = [],
    onToggle,
    onPin,
}) => (
    <div
        className={classNames(
            s.Root,
            modifiers.map((modifier) => s[`Root--${modifier}`]),
            { [s['Root--Toggle']]: showToggle }
        )}
        onClick={showToggle ? onToggle : undefined}>
        <div className={s.Title}>
            <h2 className={s.Label}>{label}</h2>
            <span className={s.Count}>{count}</span>
        </div>
        <div className={s.Actions}>
            {/* An open section shows which of its reports are new. */}
            {hasNewReports && !isOpen && (
                <span className={s.Status}>
                    <Status
                        modifier="Thin"
                        statusColor="Pink"
                        statusText={t('categoryHeader.newReports')}
                    />
                </span>
            )}
            {showPin && (
                <button
                    type="button"
                    className={s.Button}
                    aria-pressed={isPinned}
                    aria-label={t(
                        isPinned ? 'categoryHeader.unpin' : 'categoryHeader.pin'
                    )}
                    onClick={(event) => {
                        event.stopPropagation();
                        onPin?.();
                    }}>
                    <Icon
                        name={isPinned ? 'KeepOff' : 'Keep'}
                        className={s.PinIcon}
                    />
                </button>
            )}
            {showToggle && (
                <button
                    type="button"
                    className={s.Button}
                    aria-expanded={isOpen}
                    aria-label={t(
                        isOpen
                            ? 'categoryHeader.collapse'
                            : 'categoryHeader.expand'
                    )}>
                    <Icon
                        name="ArrowRightSmall"
                        className={classNames(s.Chevron, {
                            [s['Chevron--Open']]: isOpen,
                        })}
                    />
                </button>
            )}
        </div>
    </div>
);

CategoryHeader.propTypes = {
    label: PropTypes.string,
    count: PropTypes.number,
    isOpen: PropTypes.bool,
    isPinned: PropTypes.bool,
    hasNewReports: PropTypes.bool,
    showPin: PropTypes.bool,
    showToggle: PropTypes.bool,
    modifiers: PropTypes.arrayOf(PropTypes.string),
    onToggle: PropTypes.func,
    onPin: PropTypes.func,
};

export default CategoryHeader;
